import * as util from "../../services/locations/locationAddress/util"
import ProvidersStore from "../../services/providers/ProvidersStore";
import reviewFiltersStore from "../../modules/reviews/ReviewFilterStore";

angular.module('clientDashboardApp').service('reviewProvidersService', function (providerService) {
    return {
        initializeProvidersForGroup: function(groupId) {
            return ProvidersStore.reviewProviders;
        },
        getProviders: function () {
            return ProvidersStore.reviewProviders;
        }
    }
});

angular.module('clientDashboardApp').directive('bindOnce', function() {
  return {
    scope: true,
    link: function( $scope, $element ) {
      setTimeout(function() {
        $scope.$destroy();
        $element.removeClass('ng-binding ng-scope');
      }, 0);
    }
  }
});

angular.module('clientDashboardApp').controller("ReviewsTabParentController",
  function ($scope, $location, locationService, listingService, configService, $rootScope, reactContainer) {

    $scope.locationSummaries = {};
    $scope.addressSummaries = {};
    $scope.respondableListings = [];

    configService.getBrandConfig(false, false).then(function (brandConfig) {
      $scope.brandConfig = brandConfig;
    });

    $scope.selectedReportType = reactContainer.getContainer().reportType || 'reviewSummary';
    $scope.showGroups = reviewFiltersStore.state.showGroups;

    let groupIdUsedForLoadingData = reviewFiltersStore.state.groupId;
    initializeLocationData();
    initializeListingsData();

    $scope.$on('$locationChangeSuccess', () => {
      const params = $location.search();
      $scope.selectedReportType = reactContainer.getContainer().reportType || 'reviewSummary';
      $scope.showGroups = reviewFiltersStore.state.showGroups;
      const groupId = reviewFiltersStore.state.groupId;
      if (groupIdUsedForLoadingData !== groupId) {
        groupIdUsedForLoadingData = groupId;
        initializeLocationData();
      }
    });

    function initializeListingsData() {
      listingService.getRespondableListingIds(reviewFiltersStore.state.groupId).then(function(result) {
        $rootScope.respondableListings = result;
      })
    }

    function initializeLocationData() {
      locationService.locationsAndGroups().then(
        locationsAndGroups =>  {
          let mappedLocations = {};
          let mappedAddresses = {};
          locationsAndGroups.groups.map(groups => mappedLocations[groups.id] = groups.name )
          locationsAndGroups.locations.map(location => {
            mappedLocations[location.id] = location.name;
            mappedAddresses[location.id] = util.formatPostalAddress(location.address)
          })
          $scope.locationSummaries = mappedLocations;
          $scope.addressSummaries = mappedAddresses;
        }
      );
    }

  });
